import { LogisticaGuiaEstado } from "@pcgerente-node/pcg-comun";
import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { conseguirGuiasRecientes, limpiarConsultaSlice, limpiarGuiasRecientesSinLoading, obtenerCiudadesConsulta, obtenerDestinatarios } from "../../../redux/actions/actionsConsulta";
import { RootState, useAppDispatch } from "../../../redux/store";
import "../../../styles/consultaGuia.css";
import { numerosNaturales, tieneUnceroALaIzquierda } from "../../../Utils/regex";
import Loading from "../../helpers/Loading/Loading";
//import DataTableGuias from "./PagedConsultasGuias/DataTableGuias";
import Paged from "./PagedConsultasGuias/Paged";

const StylesProps3: CSSProperties = {
  backgroundColor: "#ff5100",
  fontSize: "4 px",
  color: "white"
}

const StyleProps4: CSSProperties = {
  backgroundColor: "#d9d9f2"
}

const StyleProps5: CSSProperties = {
  color: "black"
}

const StyleProps8: React.CSSProperties = {
  color: "white",
  marginRight: "4px"
}



const ConsultaGuiaContent: React.FC = () => {

  const GuiasStore = useSelector((state: RootState) => state.consulta.guiasConsulta)
  const ciudadesStore = useSelector((state: RootState) => state.consulta.ciudadesConsulta)
  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
  const usuario =usuarioVM._ItemActivo
  const dispatch = useAppDispatch()

  let fechaActualFormateada = new Date().toISOString()
  fechaActualFormateada = fechaActualFormateada.slice(0, fechaActualFormateada.indexOf("T"))

  let fechaAnterior = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString()
  fechaAnterior = fechaAnterior.slice(0, fechaAnterior.indexOf("T"));

  const initialStateQuery = {
    desde: fechaAnterior,
    hasta: fechaActualFormateada,
    nombreDestinatario: "",
    numeroDocumentoRelacionado: "",
    numeroGuiaFactura: "",
    estado: LogisticaGuiaEstado.Todos,
    idCiudadDestino: 0,
    idCiudadOrigen: 0,
    error: ""
  }
  const [query, setQuery] = useState(initialStateQuery)
  const [yaHaBuscado, setYaHaBuscado] = useState(false)

  //La primera vez que carga la página nos traemmos la información base
  useEffect(() => {
    dispatch(obtenerCiudadesConsulta())
    buscarDestinatarios()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div id="content" className="main-content">
      <div className="layout-px-spacing">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="col-sm-11 text-center">
            <h3 style={StyleProps5}>Consulta de Guías</h3>
          </div>
          <div className="col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11 layout-spacing">

            <form className="form-inline" onSubmit={(e) => e.preventDefault()}>


              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Origen</div>
                </div>
                <select className=" form-control-plaintext"
                  style={StyleProps4}
                  color="white"
                  value={query.idCiudadOrigen}
                  onChange={(e) => handleQuery(e, "idCiudadOrigen")}
                >
                  <option hidden>Buscar Ciudad</option>
                  <option value={0} >Todos</option>
                  {ciudadesStore.info.map(ciudad =>
                    <option key={ciudad.id} value={ciudad.id}>{ciudad.nombre}</option>
                  )}
                </select>
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>#Guia:</div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroupUsername2"
                  value={query.numeroGuiaFactura}
                  onKeyDown={(e) => handleEnter(e, true)}
                  onChange={(e) => handleQuery(e, "numeroGuiaFactura")}
                />
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Estado</div>
                </div>
                <select className=" form-control-plaintext"
                  style={StyleProps4}
                  color="white"
                  value={query.estado}
                  onChange={(e) => handleQuery(e, "estado")}
                >
                  <option value={LogisticaGuiaEstado.Todos}>Todos</option>
                  <option value={LogisticaGuiaEstado.Planta}>En planta</option>
                  <option value={LogisticaGuiaEstado.Viaje}>Enviado</option>
                  <option value={LogisticaGuiaEstado.RecibidoEnBodegaTransito}>En bodega</option>
                  <option value={LogisticaGuiaEstado.Ruta}>En ruta</option>
                  <option value={LogisticaGuiaEstado.Recibido}>Recibido</option>
                  <option value={LogisticaGuiaEstado.Entregada}>Entregado</option>
                  <option value={LogisticaGuiaEstado.Devuelta}>Devuelta</option>
                  <option value={LogisticaGuiaEstado.Anulado}>Anulado</option>
                </select>
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-2">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Desde</div>
                  <input
                    type="date"
                    className="form-control"
                    id="date"
                    placeholder=""
                    value={query.desde}
                    onKeyDown={(e) => handleEnter(e, false)}
                    onChange={(e) => handleQuery(e, "desde")}
                  />
                </div>
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Destino</div>
                </div>
                <select className=" form-control-plaintext"
                  style={StyleProps4}
                  color="white"
                  value={query.idCiudadDestino}
                  onChange={(e) => handleQuery(e, "idCiudadDestino")}>
                  <option hidden>Buscar Ciudad</option>
                  <option value={0} >Todos</option>

                  {ciudadesStore.info.map(ciudad =>
                    <option key={ciudad.id} value={ciudad.id}>{ciudad.nombre}</option>
                  )}
                </select>

              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>#G.Remisión</div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroupUsername2"
                  value={query.numeroDocumentoRelacionado}
                  onKeyDown={(e) => handleEnter(e, true)}
                  onChange={(e) => handleQuery(e, "numeroDocumentoRelacionado")}
                />
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-3">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Destinatario</div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroupUsername2"
                  value={query.nombreDestinatario}
                  onKeyDown={(e) => handleEnter(e, true)}
                  onChange={(e) => handleQuery(e, "nombreDestinatario")}
                />
              </div>

              <div className="input-group mb-2 mr-sm-2 col-sm-2">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Hasta</div>
                  <input
                    type="date"
                    className="form-control"
                    id="date"
                    placeholder=""
                    value={query.hasta}
                    onKeyDown={(e) => handleEnter(e, false)}
                    onChange={(e) => handleQuery(e, "hasta")}
                  />
                </div>
              </div>

              <div className="col-sm-12 text-center">
                <button
                  onClick={() => restablecerFiltrado()}
                  className="btn btn-danger col-sm-3 mt-1 mb-1"
                  style={StyleProps8}
                  disabled={yaHaBuscado?(GuiasStore.loading ): false}
                >
                  Restablecer
                </button>

                <button
                  name="search"
                  className="btn btn-primary btn-block- col-sm-3 mt-1 mb-1"
                  onClick={() => buscarGuia(true)}
                  disabled={yaHaBuscado?(GuiasStore.loading ): false}
                >
                  Buscar
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
          <div className="widget-content">
            <div className="d-flex justify-content-center mt-2 mb-2">
              <span className="text-danger" style={{fontSize: "1.2rem"}}>{query.error}</span>
            </div>
            {GuiasStore.errorUndefined? //Si tira error el servidor
              <div className="d-flex align-items-center flex-column">
                <button className="d-flex btn btn-primary mb-3 mt-2" onClick={() => limpiarRedux()}>Reintentar</button>
                <span className="d-flex text-center">Ha ocurrido un error</span>
              </div>
              : yaHaBuscado === false? //Si aún el usuario no realiza una búsqueda
                  <div className="d-flex justify-content-center">
                    <span className="text-center pt-2" style={{ fontSize: "1.5rem" }}>Aún no se ha realizado una búsqueda</span>
                  </div>
              
              :GuiasStore.loading === false  && ciudadesStore.loading === false ? //Ya maneja la información
                <div>
                  {GuiasStore.info.length > 0 && ciudadesStore.info.length > 0 ?
                    <Paged
                      contenido={GuiasStore.info}
                      ciudades={ciudadesStore.info}
                    />
                    :
                    <div className="d-flex justify-content-center">
                      <span className="text-center text-danger pt-2" style={{ fontSize: "1.5rem" }}>
                        {query.error ?"":"No se econtraron Guias"}
                      </span>
                    </div>
                  }
                </div>
                : 
                <Loading /> 
              }
          </div>
        </div>
      </div>
    </div>
  )

  function handleQuery(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, type: "desde"|"hasta"|"nombreDestinatario"|"numeroDocumentoRelacionado"|"numeroGuiaFactura"|"estado"|"idCiudadDestino"|"idCiudadOrigen"|"error") {

    if (type === "desde") {
      setQuery({
        ...query,
        desde: e.target.value
      })
    }
    if (type === "hasta") {
      setQuery({
        ...query,
        hasta: e.target.value
      })
    }

    if (type === "estado") {
      setQuery({
        ...query,
        estado: e.target.value as LogisticaGuiaEstado
      })
    }
    if (type === "nombreDestinatario") {
      setQuery({
        ...query,
        nombreDestinatario: e.target.value
      })
    }


    if (type === "idCiudadDestino") {
      setQuery({
        ...query,
        idCiudadDestino: Number(e.target.value)
      })
    }

    if (type === "idCiudadOrigen") {
      setQuery({
        ...query,
        idCiudadOrigen: Number(e.target.value)
      })
    }
    if (["numeroDocumentoRelacionado", "numeroGuiaFactura"].includes(type) && ((numerosNaturales(e.target.value) && !tieneUnceroALaIzquierda(e.target.value)) || e.target.value === "" )) {
      setQuery({
        ...query,
        [type]: e.target.value
      })
    }
  }

  function restablecerFiltrado() {
    setQuery(initialStateQuery)
  }


function buscarDestinatarios(){
  dispatch(obtenerDestinatarios(query.desde, query.hasta))
}

  async function buscarGuia(limpiarGuias: boolean) {
    try {
      if(yaHaBuscado === false){
        setYaHaBuscado(true)
      }
      if (limpiarGuias) {
        limpiarRedux()
        dispatch(obtenerCiudadesConsulta())
        buscarDestinatarios()
      }
      await dispatch(conseguirGuiasRecientes(
        query.desde, 
        query.hasta, 
        stringToNumber(query.numeroDocumentoRelacionado,0), 
        query.nombreDestinatario, 
        query.estado, 
        query.idCiudadDestino, 
        query.idCiudadOrigen,
        stringToNumber(query.numeroGuiaFactura,0),
        usuario.id
        ))
        setQuery({...query, error: ""})
    }catch (error) {
      if(error instanceof Error){
        dispatch(limpiarGuiasRecientesSinLoading())
        setQuery({...query, error: error.message})
      }
    }
  }

  function limpiarRedux() {
    dispatch(limpiarConsultaSlice("manifiestos"))
  }
  function stringToNumber(string: string, _default: number){
    if(!isNaN(Number(string))){
      return Number(string)
    }else{
      return _default
    }
  }

  function handleEnter(e: React.KeyboardEvent<HTMLInputElement>, puedeBuscar: boolean) {
    if (e.key === "Enter") {
      e.preventDefault()
      if (GuiasStore.loading === false  && puedeBuscar)
        buscarGuia(false)
    }
  }

}


export default ConsultaGuiaContent